(function () {
    'use strict';
    var m = angular.module('widgets');
    m.directive('actions', ["path", "modals", "widgetLogic", "feature", function (path, modals, widgetLogic, feature) {
        function stateIcon(state) {
            if (state === 'in_progress') {
                return '#' + JSON.stringify({
                    display: 'text',
                    'class': 'fa fa-spinner fa-pulse action-state-in_progress'
                });
            }
            if (state === 'error') {
                return '#' + JSON.stringify({
                    display: 'text',
                    'class': 'fa fa-exclamation-circle action-state-error'
                });
            }
            return '';
        }
        function fieldEqual(data, keys, value) {
            if (keys.length === 0) {
                return false;
            }
            if (keys.length === 1) {
                return data[keys[0]] === value;
            }
            if (_(data[keys[0]]).isUndefined()) {
                return false;
            }
            return fieldEqual(data[keys[0]], _(keys).rest(), value);
        }
        function valueByKeys(data, keys) {
            if (keys.length === 0) {
                return;
            }
            if (keys.length === 1) {
                return data[keys[0]];
            }
            if (_(data[keys[0]]).isUndefined()) {
                return;
            }
            return valueByKeys(data[keys[0]], _(keys).rest());
        }
        function fieldContains(data, key, value) {
            var keyData = valueByKeys(data, key);
            if (!_(keyData).isString() || !_(value).isString()) {
                return false;
            }
            return keyData.indexOf(value) !== -1;
        }
        function fieldPartOf(data, key, value) {
            var keyData = valueByKeys(data, key);
            if (!_(keyData).isString() || !_(value).isString()) {
                return false;
            }
            return value.indexOf(keyData) !== -1;
        }
        function fieldMatches(data, key, compareWith) {
            var keys = key.split('.');
            if (compareWith && compareWith.src_key) {
                keys = compareWith.src_key.split('.');
            }
            var value = compareWith;
            if (compareWith && compareWith.operator) {
                if (compareWith.key) {
                    value = valueByKeys(data, compareWith.key.split('.'));
                } else {
                    value = compareWith.value;
                }
            }
            if (compareWith && compareWith.operator === 'not_equal') {
                return !fieldEqual(data, keys, value);
            }
            if (compareWith && compareWith.operator === 'equal') {
                return fieldEqual(data, keys, value);
            }
            if (compareWith && compareWith.operator === 'contains') {
                return fieldContains(data, keys, value);
            }
            if (compareWith && compareWith.operator === 'partof') {
                return fieldPartOf(data, keys, value);
            }
            if (compareWith && compareWith.operator === 'not_partof') {
                return !fieldPartOf(data, keys, value);
            }
            if (compareWith && compareWith.operator === 'defined') {
                return !_(valueByKeys(data, keys)).isUndefined();
            }
            return fieldEqual(data, keys, compareWith);
        }
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('widgets').directive('actions').template(),
            scope: { model: '=actions' },
            link: function ($scope, element, attr) {
                widgetLogic($scope, $scope.model.logic);
                $scope.guiV2 = feature.guiV2;
                function isHidden(action) {
                    if (action.hiddenEntityByApi && $scope.model.actionStatus) {
                        return !_(action.hiddenEntityByApi).chain().find(function (value, key) {
                            return fieldMatches($scope.model.actionStatus, key, value);
                        }).isUndefined().value();
                    }
                    if (!action.hiddenEntityAll && !action.hiddenEntityAny && !action.hiddenSecEntityAny) {
                        return false;
                    }
                    if (!$scope.model.entityData && !$scope.model.secEntityData) {
                        return true;
                    }
                    var hidden = false;
                    if (action.hiddenEntityAny) {
                        hidden = !_(action.hiddenEntityAny).chain().find(function (value, key) {
                            return fieldMatches($scope.model.entityData, key, value);
                        }).isUndefined().value();
                    }
                    if (!hidden && action.hiddenSecEntityAny) {
                        hidden = _(action.hiddenSecEntityAny).chain().find(function (value, key) {
                            return $scope.model.secEntityData && $scope.model.secEntityData[key] && !_(value).find(function (val, k) {
                                return fieldMatches($scope.model.secEntityData[key], k, val);
                            });
                        }).isUndefined().value();
                    }
                    if (!hidden && action.hiddenEntityAll) {
                        if (!_(action.hiddenEntityAll).isArray()) {
                            hidden = _(action.hiddenEntityAll).chain().find(function (value, key) {
                                return !fieldMatches($scope.model.entityData, key, value);
                            }).isUndefined().value();
                        } else {
                            hidden = !_(action.hiddenEntityAll).chain().find(function (block) {
                                return _(block).chain().find(function (value, key) {
                                    return !fieldMatches($scope.model.entityData, key, value);
                                }).isUndefined().value();
                            }).isUndefined().value();
                        }
                    }
                    return hidden;
                }
                $scope.isDisabled = function (action) {
                    if (action.disabledEntityByApi && $scope.model.actionStatus) {
                        return !_(action.disabledEntityByApi).chain().find(function (value, key) {
                            return fieldMatches($scope.model.actionStatus, key, value);
                        }).isUndefined().value();
                    }
                    if (processActionStatus(action).disabled) {
                        return true;
                    }
                    if (!$scope.model.entityData || !action.disabledEntityAll && !action.disabledEntityAny) {
                        return false;
                    }
                    return processEntityDisabled(action).disabled;
                };
                function processEntityDisabled(action) {
                    var result = { disabled: false };
                    if (!$scope.model.entityData || !action.disabledEntityAll && !action.disabledEntityAny) {
                        return result;
                    }
                    if (action.disabledEntityAny) {
                        var field = _(action.disabledEntityAny).find(function (value, key) {
                            return fieldMatches($scope.model.entityData, key, value);
                        });
                        if (field) {
                            result.disabled = true;
                            result.tooltip = field.tooltip;
                            return result;
                        }
                    }
                    if (action.disabledEntityAll) {
                        result.disabled = _(action.disabledEntityAll).chain().find(function (value, key) {
                            if (key === 'tooltip') {
                                return false;
                            }
                            return !fieldMatches($scope.model.entityData, key, value);
                        }).isUndefined().value();
                        if (result.disabled) {
                            result.tooltip = action.disabledEntityAll.tooltip;
                        }
                    }
                    return result;
                }
                function processActionStatus(action) {
                    var result = {};
                    if (!$scope.model.entityData || !$scope.model.entityData.actions_status || !$scope.model.entityData.actions_status[action.actionType]) {
                        return result;
                    }
                    var status = $scope.model.entityData.actions_status[action.actionType];
                    if (status.description) {
                        result.tooltip = status.description;
                    }
                    if (status.label) {
                        if (status.state === 'in_progress' || status.state === 'error' && !status.allow_retry) {
                            result.label = stateIcon(status.state) + ' ' + status.label;
                        } else {
                            result.label = status.label;
                        }
                    }
                    if (status.allow_retry === false) {
                        result.disabled = true;
                    }
                    return result;
                }
                $scope.actionTooltip = function (action) {
                    var tooltip = processActionStatus(action).tooltip;
                    if (!tooltip) {
                        tooltip = processEntityDisabled(action).tooltip;
                    }
                    if (!tooltip) {
                        return null;
                    } else {
                        return {
                            content: { text: tooltip },
                            position: {
                                at: 'bottom center',
                                my: 'top center'
                            },
                            style: {
                                classes: 'qtip-standard max-half-window',
                                def: false
                            }
                        };
                    }
                };
                $scope.actionLabel = function (action) {
                    return processActionStatus(action).label || $scope.isDisabled(action) && action.label_disabled || action.label;
                };
                $scope.isActionVisible = function (action) {
                    return (_(action.noFeature).isUndefined() || !feature[action.noFeature]) && (_(action.feature).isUndefined() || feature[action.feature]) && action.label && !isHidden(action);
                };
                $scope.actionClick = function (action) {
                    if (!$scope.isDisabled(action) && action.onClick) {
                        action.onClick();
                    }
                };
            }
        };
    }]);
}());